/**
 * Whether a value is an actual partner id rather than an organisation placeholder.
 *
 * Before a partner completes signup, the session is attached to a shared organisation
 * called "initial signup organization". Treating that as a partner id would put the SAME
 * value on every pre-signup event — valid-looking and wrong, which is harder to notice
 * than an empty field.
 *
 * Real ids are opaque and contain no spaces (e.g. "BnGJbePA"), so a space is a reliable
 * marker of an organisation name.
 */
export var isRealPartnerId = function (id) {
    return !!id && !id.includes(" ") && id.toLowerCase() !== "initial signup organization";
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNSZWFsUGFydG5lcklkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiaXNSZWFsUGFydG5lcklkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7O0dBVUc7QUFDSCxNQUFNLENBQUMsSUFBTSxlQUFlLEdBQUcsVUFBQyxFQUFrQjtJQUNoRCxPQUFBLENBQUMsQ0FBQyxFQUFFLElBQUksQ0FBQyxFQUFFLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxXQUFXLEVBQUUsS0FBSyw2QkFBNkI7QUFBL0UsQ0FBK0UsQ0FBQyJ9